const FULL_SCREEN_EXIT_STATES = {
    WARNING_STEP : 'WARNING_STEP',
    PROCTORING_SETUP_STEP : 'PROCTORING_SETUP_STEP',
    AUTO_SUBMIT_ATTEMPT: 'AUTO_SUBMIT_ATTEMPT'
}

export default FULL_SCREEN_EXIT_STATES